import { Review } from '../../../models/review';
import { EntityState } from '@ngrx/entity';
import { aiAssistedRepliesAdapter, aiDefaultLanguagesAdapter, aiSettingsAdapter, replyTemplatesAdapter, reviewsAdapter, reviewTranslationsAdapter } from './review-adapters';
import { ReplyTemplate } from '../reply-tab-group/template-selection/template-selection.component';
import { AiAssistedRepliesPerReview } from '../../../models/ai-assisted-replies-per-review';
import { AiSettings } from '../reply-tab-group/ai-replies-settings/ai-replies-settings.component';
import { ReviewFilters } from '../../../models/review-filters';
import { SortType } from '../../../models/campaigns-models/campaign-filters';
import { ReviewTranslation } from '../../../models/review-translation';

export interface ReviewsState extends EntityState<Review> {
}

export interface ReviewTranslationsState extends EntityState<ReviewTranslation> {
}

export interface ReplyTemplatesState extends EntityState<ReplyTemplate> {
}

export interface AiAssistedRepliesState extends EntityState<AiAssistedRepliesPerReview> {
}

export interface AiSettingsState extends EntityState<AiSettings> {
}

export interface AiDefaultLanguagesState extends EntityState<AiRepliesLanguage> {
}

export interface AiRepliesLanguage {
  key: string,
  enName: string,
  deName: string,
  emojiCode: string
}

export interface ReviewFeatureState {
  // review BE data
  reviews: ReviewsState;
  reviewTranslations: ReviewTranslationsState;
  totalNumber: number;
  from: string; //ISO String in format: "2023-07-01T00:00:00.000Z"
  to: string; //ISO String in format: "2023-07-01T00:00:00.000Z"

  // review reply templates BE data
  replyTemplates: ReplyTemplatesState;

  // AI-assisted replies
  aiAssistedReplies: AiAssistedRepliesState;

  // AI settings
  aiSettings: AiSettingsState;
  // a list of language codes, i.e. 'EN', 'DE', etc. to choose from in the default language drop down
  defaultLanguages: AiDefaultLanguagesState;

  // below UI data are also accessed by ngrx review effects / filter bar component, hence they're
  // placed here and not in component local store(s)

  // current filters
  filters: ReviewFilters;

  // paginator
  pageSize: number,
  pageIndex: number,
}

export const InitialState: ReviewFeatureState = {
  reviews: reviewsAdapter.getInitialState(),
  reviewTranslations: reviewTranslationsAdapter.getInitialState(),
  replyTemplates: replyTemplatesAdapter.getInitialState(),
  aiAssistedReplies: aiAssistedRepliesAdapter.getInitialState(),
  aiSettings: aiSettingsAdapter.getInitialState(),
  defaultLanguages: aiDefaultLanguagesAdapter.getInitialState(),
  totalNumber: null,
  from: null,
  to: null,
  filters: {
    storeCodes: [],
    businessNames: [],
    countryCodes: [],
    cities: [],
    gbpAccountIds: [],
    from: null,
    to: null,
    sortType: SortType.NEWEST,
    reviewType: null,
    reply: null,
    edit: null,
    rating: [],
  },
  pageSize: 10,
  pageIndex: 0,
};
